export class RiderPrivateContact {
	riderUid = "";
	phone = "";
	address = { streetAddress: "", unit: "", city: "", state: "", zip: "" };
	emergencyContact = { name: "", relationship: "", phone: "" };
	build(value: any) { if (value) { this.riderUid = value.riderUid || ""; this.phone = value.phone || ""; this.address = { ...this.address, ...(value.address || {}) }; this.emergencyContact = { ...this.emergencyContact, ...(value.emergencyContact || {}) }; } return this; }
}
